import { Box } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { NotFound } from '../../../../pages';
import { validate as validateUuid } from 'uuid';

export default function TTSFormSuccess() {
  const {state} = useLocation();
  if(!state?.uuid){
    return <NotFound />;
  }

  if (!validateUuid(state.uuid)) {
    return <NotFound />;
  }

  return (
    <>
      <Box sx={{ padding: "20px", textAlign: "center" }}>
        <p>
          Müşteri temsilcimiz, indirim oranınızı öğrenmeniz için yakında sizinle
          irtibata geçecektir.{" "}
          <span>
            <a href="/" style={{ color: "#ed6c02" }}>İlginiz için teşekkür ederiz.</a>
          </span>
        </p>
      </Box>
    </>
  );
}
